(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DichiarazioneController', DichiarazioneController);

    // inca$ - aggiunta gestione search, $uibModal
    DichiarazioneController.$inject = ['$scope', '$state', '$uibModal', 'DataUtils', 'Dichiarazione', 'DichiarazioneSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DichiarazioneController ($scope, $state, $uibModal, DataUtils, Dichiarazione, DichiarazioneSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;
        // inca$ - gestione stato colorato
        vm.statoColour = statoColour;
        vm.rupName = rupName;
        
        function rupName (dichiarazione) {
       		return dichiarazione.decisione.responsabileProcedimento.user.firstName+" "+dichiarazione.decisione.responsabileProcedimento.user.lastName;
        }

        function statoColour (stato) {
        	//return "stato-visibile-field form-control"; // default
        	var classField = "stato-field-table";
        	if (stato=='IN_COMPILAZIONE')
        		classField = classField+" stato-field-compilatore";
        	else if (stato=='INVIATO')
        		classField = classField+" stato-field-responsabile";
        	else if (stato=='RIFIUTATO_DA_RESPONSABILE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_AMMINISTRAZIONE')
        		classField = classField+" stato-field-amministrazione";
        	else if (stato=='RIFIUTATO_DA_AMMINISTRAZIONE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_DIRETTORE')
        		classField = classField+" stato-field-direttore";
        	else if (stato=='RIFIUTATO_DA_DIRETTORE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='VALIDATO')
        		classField = classField+" stato-field-completato";
        	return classField;
        }

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DichiarazioneSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Dichiarazione.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dichiaraziones = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

     // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return DichiarazioneSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('dichiarazione', null, { reload: 'dichiarazione' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();
